import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function NotAuthorized() {
  const navigate = useNavigate();
  const { userRoles } = useAuth();

  const handleGoHome = () => {
    // Admins go to dashboard, others go to login page
    if (userRoles.includes('Admin')) {
      navigate('/dashboard');
    } else {
      navigate('/');
    }
  };

  return (
    <Box sx={{ display: 'flex', height: '80vh', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h4" component="h1">Not Authorized</Typography>
      <Typography variant="body1">You do not have permission to view this page.</Typography>
      <Button variant="contained" onClick={handleGoHome}>Go Home</Button>
    </Box>
  );
}
